import React, { useState } from "react";
import styled from "styled-components";
import ExportTablesModal from "./export.tables.modal";
import OutlinedButton from "../../../../../app/components/buttons/outlined";

const TableControls = ({ detailsView, type }) => {
  const [open, setOpen] = useState(false);

  return (
    <Container>
      <OutlinedButton onClick={() => setOpen(true)}>
        Export Tables
      </OutlinedButton>

      <ExportTablesModal
        open={open}
        detailsView={detailsView}
        onClose={() => setOpen(false)}
        type={type}
      />
    </Container>
  );
};

export default TableControls;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  height: fit-content;
  width: 100%;
`;
